<svg preserveAspectRatio="xMidYMid meet" class="icon" [ngClass]="iconClass" [style.width.px]="iconWidth">
  <use [attr.xlink:href]="'assets/images/icons_' + iconFile + '.svg#' + iconName"></use>
</svg>
